import { useState, useCallback } from 'react'
import type { SectionKey } from './types'

export function useSectionVisibility() {
  const [hidden, setHidden] = useState<Set<SectionKey>>(new Set())

  const toggleSection = useCallback((key: SectionKey) => {
    setHidden((prev) => {
      const next = new Set(prev)
      if (next.has(key)) {
        next.delete(key)
      } else {
        next.add(key)
      }
      return next
    })
  }, [])

  const isVisible = useCallback((key: SectionKey) => !hidden.has(key), [hidden])

  return { isVisible, toggleSection }
}
